const queries = (builder) => ({
  getCreditCards: builder.query({
    query: () => '/credit_cards',
  }),

  getCreditCardDetails: builder.query({
    query: (cardId) => `/credit_cards/${cardId}`,
  }),

  addCreditCard: builder.mutation({
    query: (newCard) => ({
      url: '/credit_cards',
      method: 'POST',
      body: newCard,
    }),
  }),

  updateCreditCard: builder.mutation({
    query: ({ cardId, updatedCard }) => ({
      url: `/credit_cards/${cardId}`,
      method: 'PUT',
      body: updatedCard,
    }),
  }),

  deleteCreditCard: builder.mutation({
    query: (cardId) => ({
      url: `/credit_cards/${cardId}`,
      method: 'DELETE',
    }),
  }),

});

export {
  queries as creditCardsApi,
};
